type Config = {
  apiBaseUrl: string;
  baseUrlMappings?: {
    prefix: string;
    baseUrl: string;
  }[];
};

export function baseApiUrlResolver(config: Config) {
  const { apiBaseUrl, baseUrlMappings } = config;

  return function composeURL(path: string): URL {
    if (baseUrlMappings) {
      for (const config of baseUrlMappings) {
        if (path.startsWith(config.prefix)) {
          console.info("Using baseUrlMapping for path", path, config);
          return new URL(`${config.baseUrl}/${path}`);
        }
      }
    }

    return new URL(`${apiBaseUrl}/${path}`);
  };
}
